import PropTypes from "prop-types";

import PersonPresenter from "presenters/PersonPresenter";
import FacePresenter from "presenters/FacePresenter";
import DisplayPerson from "components/DisplayPerson";

import FaceContainer from "../FaceContainer";

const FacesList = ({ faces, faceSelected, setFaceSelected }) => {
  return faces?.map((face) => (
    <FaceContainer pb={{ xs: 3, mobile: 4 }} key={face.id}>
      <DisplayPerson
        face={face}
        showCheck
        faceSelected={faceSelected}
        onCheck={(faceChecked) => setFaceSelected(faceChecked)}
      />
    </FaceContainer>
  ));
};

FacesList.propTypes = {
  people: PropTypes.arrayOf(FacePresenter.shape()),
  faceSelected: PropTypes.oneOfType([PersonPresenter.shape(), FacePresenter.shape()]),
  setFaceSelected: PropTypes.func.isRequired,
};

export default FacesList;
